import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";

import { MedIconListBulletComponent } from "./med-icon-list-bullet.component";

@NgModule({
  declarations: [
    MedIconListBulletComponent,
  ],
  imports: [
    CommonModule,
  ],
  exports: [
    MedIconListBulletComponent,
  ],
})
export class MedIconListBulletModule { }
